export default {"src":"/_next/static/media/basket.77dec474.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};